export const routes = {
    login: "/login",
    register: "/register",
    emailReset: "/email-reset",
    codeReset: "/code-reset",
    passwordReset: "/password-reset",
    home: "/",
    periodic: "/periodic",
    dataRoute: {
        data: "/data",
        interactiveMap: "/data/hbscan/interactiveMap",
        globalDashboard: "/data/hbscan/globalDashboard",
        timesheet: "/data/hbscan/timesheet",
        workingRoad: "/data/hbscan/working-road",
        trashcanDashboard: "/data/trashcan/dashboard",
        trashcanSensor: "/data/trashcan/sensor",
        periodics: "/data/hbscan/periodicals",
        periodicValidation: "/data/hbscan/periodicals/PeriodicValidation",
        periodicsDashboard: "/data/periodics/dashboard",
        periodicAdd: "add",
        employeeFeedback: "/data/hbscan/employeeFeedback",
        employeeFeedbackDetails: "details",
        scans: "/data/hbscan/scans",
        formTemplates: "/data/hbscan/formTemplates",
        formTemplateEdit: "/data/hbscan/formTemplates/edit",
        filledForms: "/data/hbscan/filledForms",
        filledForm: "/data/hbscan/filledForms/:id",
        eslTemplates: "/data/hbscan/eslTemplates",
        eslTemplateEditor: "edit",
    },
    forms: {
        serviceRequest: "/forms/serviceRequest/:companyId?/:localIdOrCode",
    },
    tableRoute: {
        table: "/table",
        companyEdit: "/table/location/company",
        buildings: "/table/location/buildings",
        buildingAdd: "add",
        profiles: "/table/location/profiles",
        profileAdd: "add",
        profileEdit: "edit",
        buildingEdit: "edit",
        floors: "/table/location/floors",
        floorAdd: "add",
        floorEdit: "edit",
        propertyGroups: "/table/location/property",
        routes: "/table/location/route",
        routeAdd: "add",
        routeEdit: "edit",
        propertyGroupAdd: "add",
        propertyGroupEdit: "edit",
        locals: "/table/location/locals",
        localAdd: "add",
        tasks: "/table/location/tasks",
        localEdit: "edit",
        users: "/table/location/users",
        userAdd: "add",
        userEdit: "edit",
        contacts: "/table/location/contacts",
        contactAdd: "add",
        contactEdit: "edit",
    },
    servicePlus: {
        installation: "/serviceplus/installation/:buildingId/:macAdress",
        setupComplete: "/service-setup-complete",
        setupError: "/service-setup-error",
    },
    notFound: "*",
};
